export const POST_AUTH_LOADING = "products/loading";
export const POST_AUTH_SUCCES = "products/success";
export const POST_AUTH_ERROR = "products/error";